<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="bar-container" [class.is-v3]="variant === 'v3'">
  <div class="bar-column" *ngFor="let row of chartData">
    <div class="bar-progress-outer">
      <div class="bar-progress-box" *ngIf="row.score" [style.height.%]="(row.selectedCount / row.allResponsesCount) * 100">
        {{ row.selectedCount }}
      </div>
    </div>
    <div class="bar-title extra-small">{{ row.label }}</div>
  </div>
</div>
